var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActioncubeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F1F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 12.8518L16 16M16 16L10.3333 12.8518M16 16L16 22.3333M22 18.7057V13.2943C22 13.0659 22 12.9517 21.9663 12.8498C21.9366 12.7597 21.8879 12.677 21.8236 12.6072C21.7509 12.5283 21.651 12.4728 21.4514 12.3619L16.518 9.62114C16.329 9.5161 16.2344 9.46358 16.1343 9.44299C16.0457 9.42477 15.9543 9.42477 15.8657 9.44299C15.7656 9.46358 15.6711 9.5161 15.482 9.62114L10.5486 12.3619C10.349 12.4728 10.2491 12.5283 10.1764 12.6072C10.1121 12.677 10.0634 12.7597 10.0337 12.8498C10 12.9517 10 13.0659 10 13.2943V18.7057C10 18.9341 10 19.0484 10.0337 19.1502C10.0634 19.2403 10.1121 19.3231 10.1764 19.3929C10.2491 19.4718 10.349 19.5272 10.5486 19.6382L15.482 22.3789C15.6711 22.4839 15.7656 22.5365 15.8657 22.557C15.9543 22.5753 16.0457 22.5753 16.1343 22.557C16.2344 22.5365 16.329 22.4839 16.518 22.3789L21.4514 19.6382C21.651 19.5272 21.7509 19.4718 21.8236 19.3929C21.8879 19.3231 21.9366 19.2403 21.9663 19.1502C22 19.0484 22 18.9341 22 18.7057Z",
    stroke: "#393E44",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActioncubeicon);
export default __webpack_public_path__ + "static/media/action cube icon.032e6672f127e06bb55c61766fb9bfb1.svg";
export { ForwardRef as ReactComponent };